import { render, staticRenderFns } from "./Crashes.vue?vue&type=template&id=07acf020"
import script from "./Crashes.vue?vue&type=script&lang=js"
export * from "./Crashes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports